import { http } from "@/core/ApiConfig";
import { Service } from "../shared/Service";

export class AssinanteService extends Service{

  constructor(){
    super('assinante');
  }

  GetLogo(){
    return http.get(`${this.GetNomeControle()}/logo`);
  }

  SalvarLogo(arquivo: any){
    let bodyFormData = new FormData();
    // bodyFormData.append('arquivo', new Blob([arquivo], { type: 'image/jpeg' }), arquivo.name);
    bodyFormData.append('arquivo', arquivo);

    return http.post(`${this.GetNomeControle()}/logo`, bodyFormData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
        }
    });
  }

}